import { UUID } from './uuid';
export class Region {
  constructor(init?: Partial<Region>) {
    Object.assign(this, init);
  }
  public id: UUID;
  public name: string;
  public is_active: boolean;
}
